export default __webpack_public_path__ + "static/charter-lockup-73638ecc1f24af4cfaff25f309e2b74f.png";